/* global hUrl */
import getLocalStorage from './functions/_localStorage-getLocalStorage.js' // LocalStorageを取得
import setLocalStorage from './functions/_localStorage-setLocalStorage.js' // LocalStorageに保存
// const hogeString = getLocalStorage('hogeString', 'string') // LocalStorageを取得
// const hogeInt = getLocalStorage('hogeInt', 'int') // LocalStorageを取得
// const hogeArray = getLocalStorage('hogeArray', 'array') // LocalStorageを取得

// setLocalStorage('hogeText', 'hoge', 'string') // LocalStorageに保存
// setLocalStorage('hogeArray', ['hoge','fuga'], 'array') // LocalStorageに保存

// ログイン時に未読を探してポップアップ
if (document.getElementById('state-login')) {
  unread()
}

function unread() {
  const checkSec = 60 * 3 // チェック間隔（秒）
  let ajax = false // Ajaxリクエスト

  // チェック時間かどうかを確認
  function nextCheck() {
    let nextCheck = getLocalStorage('unread_next', 'int') // LocalStorageを取得

    // UNIXタイムスタンプを取得する (ミリ秒単位)
    const timestamp = new Date().getTime()
    // 秒単位に直す
    const timestampSec = Math.floor(timestamp / 1000)

    if (nextCheck < timestampSec) {
      const url = hUrl + 'api/'

      getNewCount(url, 'type=unread')

      // 次のチェック時間を記録
      const timestampSecNext = timestampSec + checkSec

      setLocalStorage('unread_next', timestampSecNext, 'string') // LocalStorageに保存
    } else {
      // console.log(nextCheck - timestampSec)
    }
  }
  nextCheck()

  setInterval(() => {
    nextCheck()
  }, 1000)

  function getNewCount(url, param) {
    const loadingItem = document.createElement('div')
    loadingItem.className = 'md-loading active'

    if (ajax) {
      // 既に通信中なら切断
      ajax.abort()
    }

    ajax = new XMLHttpRequest() // Ajaxリクエスト

    if (param) {
      url += (~url.indexOf('?') ? '&' : '?') + param // パラメータをURLに結合
    }

    // Ajaxと明示するパラメータを付ける
    url += (~url.indexOf('?') ? '&' : '?') + 'ajax=1'
    ajax.open('get', url, true) // GET/POST, URL, 非同期処理

    ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー
    // キャッシュせず最新のデータを取る場合のリクエストヘッダー3種
    // ajax.setRequestHeader('Pragma', 'no-cache')
    // ajax.setRequestHeader('Cache-Control', 'no-cache')
    // ajax.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00 GMT')

    ajax.responseType = 'json' // 取得タイプ document text json
    ajax.timeout = 10000 // タイムアウト判定時間

    ajax.send() // GETリクエスト実行

    ajax.onload = function () {
      // アクセス成功
      if (ajax.status < 200 || ajax.status >= 400) {
        console.log('Error: Code ' + ajax.status) // エラー
        return
      }

      if (ajax.response['message']) {
        window.popToast(ajax.response['message'], 10000)
        if (document.getElementById('sys-messageReload')) {
          messageReload() // メッセージ欄をリロード
        }
      }
    }
    ajax.ontimeout = function (e) {
      // タイムアウト
    }
    ajax.onerror = function () {
      // Ajax処理失敗
    }
    ajax.onloadend = function () {
      // 受信成否に関わらず実行
      // intObsAjax()
      ajax = false
    }
  }
}

function messageReload() {
  /*
     ###          ##    ###    ##     ##
   ##   ##        ##  ##   ##    ## ##
  ##     ##       ## ##     ##    ###
  ######### ##    ## #########   ## ##
  ##     ##  ######  ##     ## ##     ##
  */
  let ajax = false // Ajaxリクエスト

  applyAjax('./', 'get', '', '#postList', '#postList')

  /**
   * Ajax処理を実行する
   * @param url {string} 取得先のURL
   * @param from {string} 書き換え元のセレクタ　,区切りで複数指定
   * @param to {string} 取得先のセレクタ　,区切りで複数指定
   * @param pushSt {string|boolean} 擬似的にページ遷移する　falseじゃなければ有効
   * @param type {string} rep:要素を書き換える add:書き換え元の下に追加する
   * @param scroll {string} 指定の位置にスクロールさせる
   * @param flag {string} 独自の拡張用
   */
  function applyAjax(url, method = 'get', param, from, to) {
    from = from.split(',') // ,区切りで配列に変換
    to = to.split(',') // ,区切りで配列に変換

    const loadingItem = document.createElement('div')
    loadingItem.className = 'md-loading active'

    // ローディング処理
    for (let index = 0; index < to.length; index++) {
      const itemTo = document.querySelector(to[index])
      const loadingItem = document.createElement('div')
      loadingItem.className = 'md-loading active'
      loadingItem.style.width = itemTo.offsetWidth + 'px'
      loadingItem.style.height = itemTo.offsetHeight + 'px'
      itemTo.innerHTML = ''

      itemTo.appendChild(loadingItem)
    }
    if (ajax) {
      // 既に通信中なら切断
      ajax.abort()
    }
    ajax = new XMLHttpRequest() // Ajaxリクエスト

    if (param) {
      url += (~url.indexOf('?') ? '&' : '?') + param // パラメータをURLに結合
    }
    // Ajaxと明示するパラメータを付ける
    url += (~url.indexOf('?') ? '&' : '?') + 'ajax=1'
    ajax.open(method, url, true) // GET/POST, URL, 非同期処理

    ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー
    // キャッシュせず最新のデータを取る場合のリクエストヘッダー3種

    ajax.responseType = 'document' // 取得タイプ document text json
    ajax.timeout = 10000 // タイムアウト判定時間

    ajax.send() // GETリクエスト実行

    ajax.onload = function () {
      // アクセス成功
      if (ajax.status < 200 || ajax.status >= 400) {
        console.log('Error: Code ' + ajax.status) // エラー
        return
      }

      let ajaxData = ajax.response // 実際に使用するデータ

      for (let index = 0; index < to.length; index++) {
        const itemFrom = ajaxData.querySelector(from[index])
        const itemTo = document.querySelector(to[index])

        itemTo.innerHTML = itemFrom.innerHTML
      }
    }
    ajax.ontimeout = function (e) {
      // タイムアウト
    }
    ajax.onerror = function () {
      // Ajax処理失敗
    }
    ajax.onloadend = function () {
      // 受信成否に関わらず実行
      // intObsAjax()
      ajax = false
    }
  }
}
